/**
 * Carousel'deki ürün kartları şeridin (track) genişliğine göre ölçeklenir.
 * Track `@container` olduğundan sayfada başka bir kap gerekmez.
 */
export const PRODUCT_CAROUSEL_ITEM_CLASSNAME =
  "flex flex-shrink-0 w-[160px] @min-[380px]:w-[168px] @min-[520px]:w-[200px] @min-[720px]:w-[240px] @min-[960px]:w-[278px] snap-center sm:snap-none";

export const PRODUCT_CAROUSEL_TRACK_CLASSNAME =
  "@container flex items-stretch gap-3 overflow-x-auto scrollbar-hide scroll-smooth @min-[520px]:gap-4 @min-[960px]:gap-6 snap-x snap-mandatory sm:snap-none";

export function getProductCarouselCardWidth(containerWidth: number): number {
  if (containerWidth >= 960) return 278;
  if (containerWidth >= 720) return 240;
  if (containerWidth >= 520) return 200;
  if (containerWidth >= 380) return 168;
  return 160;
}

export function getProductCarouselGap(containerWidth: number): number {
  if (containerWidth >= 960) return 24;
  if (containerWidth >= 520) return 16;
  return 12;
}

export function getProductCarouselScrollStep(containerWidth?: number): number {
  const width =
    containerWidth ??
    (typeof window === "undefined" ? 1024 : window.innerWidth);
  return getProductCarouselCardWidth(width) + getProductCarouselGap(width);
}
